// extracted by mini-css-extract-plugin
module.exports = {"faultyDamaged":"faultyProducts_faultyDamaged__LQRN1"};